import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Navbar from '../Navbar';
import style from './Wrapper.module.scss';
import { withRouter } from "react-router-dom";
import routeMap from '../../config/routeMap';

class Wrapper extends Component {
  constructor(props) {
     super(props)
     this.state = {
     };
   }

  static propTypes = {
    theme: PropTypes.oneOf(['Blue', 'Green']),
    backButtonVisible: PropTypes.bool,
    isLoading: PropTypes.bool,
  };

  static defaultProps = {
    backButtonVisible: true,
    isLoading: false,
  };

  componentDidMount() {
    const currentUrl = window.location.pathname;
    if(/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      document.getElementById("root").scrollIntoView();
      setTimeout (function () {
       window.scrollTo(0,0);
      }, 100)
    } else {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
    const progress = JSON.parse(localStorage.getItem('progress')) || [];
    const allUrls = Object.values(routeMap);
    if (!progress.includes(currentUrl) && allUrls.includes(currentUrl) && window.location.pathname !== "/") {
      progress.push(currentUrl);
      localStorage.setItem('progress', JSON.stringify(progress));
      return currentUrl;
    }
  }

  render() {
    const { isLoading, theme } = this.props;

    const WrapperClasses = classNames(style.Wrapper, style[`${theme}`], { [style.isLoading]: isLoading });

    return <div className={WrapperClasses}>
        <Navbar theme={theme} backButtonVisible={this.props.backButtonVisible} />
      {this.props.children}
    </div>;
  }
}

export default withRouter(Wrapper);



// WEBPACK FOOTER //
// ./src/components/Wrapper/index.jsx